import { CHART_DEFAULT_HEIGHT, CHART_HEIGHT_ADDITIONAL_SUMMARY } from './constants';

export const getChartHeight = (
  isMobile: boolean,
  isChartFullView: boolean,
  hasAdditionalSummary = false,
  chartTitleHeight = 0
) => {
  if (!isMobile) {
    if (hasAdditionalSummary) {
      return `${CHART_HEIGHT_ADDITIONAL_SUMMARY}px`;
    }
    return `${CHART_DEFAULT_HEIGHT}px`;
  }

  const mobileViewChartHeight = isChartFullView ? 80 : 70;
  return `calc(${mobileViewChartHeight}vh - ${chartTitleHeight}px)`;
};
